import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });

export const POLE_LABELS = {
  comptabilite: "Comptabilité",
  expedition: "Expédition",
  demontage: "Démontage",
  expertise: "Expertise",
  sav: "SAV",
  magasin: "Magasin",
  call_center: "Call Center",
  stock: "Stock",
  administratif: "Administratif",
};

export const STATUS_META = {
  unassigned: {
    label: "Non pris en charge",
    bg: "bg-red-100",
    text: "text-red-800",
    dot: "bg-red-600",
  },
  processing: {
    label: "En cours",
    bg: "bg-orange-100",
    text: "text-orange-800",
    dot: "bg-orange-500",
  },
  completed: {
    label: "Traité",
    bg: "bg-green-100",
    text: "text-green-800",
    dot: "bg-green-600",
  },
  archived: {
    label: "Archivé",
    bg: "bg-zinc-100",
    text: "text-zinc-700",
    dot: "bg-zinc-500",
  },
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const ACCEPTED_EXTS = ["pdf", "png", "jpg", "jpeg", "webp", "heic", "heif", "gif"];
export const ACCEPTED_MIME = ".pdf,application/pdf,image/*";

export const isAcceptedFile = (file) => {
  if (!file) return false;
  const ext = file.name.split(".").pop()?.toLowerCase() || "";
  return ACCEPTED_EXTS.includes(ext);
};

export const fileKind = (file) => {
  const ext = file.name.split(".").pop()?.toLowerCase() || "";
  return ext === "pdf" ? "pdf" : "image";
};

export const TICKET_STATUS_LABELS = {
  new: "Nouveau",
  unassigned: "Non attribué",
  in_progress: "En cours",
  waiting_client: "En attente du client",
  client_replied: "Réponse client reçue",
  resolved: "Résolu",
  closed: "Clôturé",
};

export const TICKET_STATUS_META = {
  new: { bg: "bg-blue-100", text: "text-blue-800", dot: "bg-blue-600" },
  unassigned: { bg: "bg-red-100", text: "text-red-800", dot: "bg-red-600" },
  in_progress: { bg: "bg-orange-100", text: "text-orange-800", dot: "bg-orange-500" },
  waiting_client: { bg: "bg-purple-100", text: "text-purple-800", dot: "bg-purple-500" },
  client_replied: { bg: "bg-rose-100", text: "text-rose-800", dot: "bg-rose-600" },
  resolved: { bg: "bg-green-100", text: "text-green-800", dot: "bg-green-600" },
  closed: { bg: "bg-zinc-100", text: "text-zinc-700", dot: "bg-zinc-500" },
};

export const TICKET_PRIORITY_LABELS = {
  low: "Basse",
  normal: "Normale",
  high: "Haute",
  urgent: "Urgente",
};

export const TICKET_PRIORITY_META = {
  low: "text-zinc-500",
  normal: "text-zinc-700",
  high: "text-orange-700 font-semibold",
  urgent: "text-red-700 font-semibold",
};

export const TICKET_CATEGORY_LABELS = {
  envoyer_rib: "Envoyer un RIB",
  sav: "Service après-vente (SAV)",
  cession_vehicule: "Cession d'un véhicule",
  suivi_expedition: "Suivi d'expédition",
  suivi_retrait_piece: "Suivi d'un retrait de pièce",
  // Legacy — kept so old tickets still render a label
  remboursement: "Remboursement / RIB",
  livraison: "Livraison",
  produit_endommage: "Produit endommagé",
  produit_non_conforme: "Produit non conforme",
  disponibilite_piece: "Disponibilité pièce",
  autre: "Autre",
};

// Only these categories are shown to the client in the public portal (in this order)
export const TICKET_CATEGORY_PICKS = [
  "envoyer_rib",
  "sav",
  "cession_vehicule",
  "suivi_expedition",
  "suivi_retrait_piece",
];

// --- Commandes (Opisto) ---
export const TASK_STATUS_LABELS = {
  a_demonter: "À démonter",
  pris_en_charge: "Pris en charge",
  en_cours: "En cours",
  demontee: "Démontée",
  controlee: "Contrôlée",
  probleme: "Problème",
};

export const TASK_STATUS_META = {
  a_demonter: { bg: "bg-red-100", text: "text-red-800", dot: "bg-red-600" },
  pris_en_charge: { bg: "bg-amber-100", text: "text-amber-800", dot: "bg-amber-500" },
  en_cours: { bg: "bg-orange-100", text: "text-orange-800", dot: "bg-orange-500" },
  demontee: { bg: "bg-blue-100", text: "text-blue-800", dot: "bg-blue-600" },
  controlee: { bg: "bg-green-100", text: "text-green-800", dot: "bg-green-600" },
  probleme: { bg: "bg-fuchsia-100", text: "text-fuchsia-800", dot: "bg-fuchsia-600" },
};
